import React, { useState, useEffect } from 'react';

const TomarDatosMenoresForm = ({ onChange, initialData = [] }) => {
    const [menores, setMenores] = useState([{ nombre: '', documento: '' }]);

    useEffect(() => {
        if (initialData.length > 0) {
            setMenores(initialData);
        }
    }, [initialData]);

    const handleChange = (index, e) => {
        const { name, value } = e.target;
        const nuevosMenores = [...menores];
        nuevosMenores[index][name] = value;
        setMenores(nuevosMenores);
        onChange(nuevosMenores);
    };

    const agregarMenor = () => {
        const nuevosMenores = [...menores, { nombre: '', documento: '' }];
        setMenores(nuevosMenores);
        onChange(nuevosMenores);
    };

    const eliminarMenor = (index) => {
        const nuevosMenores = menores.filter((_, i) => i !== index);
        setMenores(nuevosMenores);
        onChange(nuevosMenores);
    };

    return (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-4">
            <h3 className="text-sm font-semibold text-gray-700">Datos de menores</h3>
            {menores.map((menor, index) => (
                <div key={index}>
                    <div className="flex gap-3 items-start">
                        <div className="flex-1 space-y-1">
                            <label className="block text-xs font-medium text-gray-500">Nombre:</label>
                            <input type="text" name="nombre" value={menor.nombre} onChange={(e) => handleChange(index, e)} required placeholder="Nombre del menor" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
                        </div>
                        <div className="flex-1 space-y-1">
                            <label className="block text-xs font-medium text-gray-500">Documento:</label>
                            <input type="text" name="documento" value={menor.documento} onChange={(e) => handleChange(index, e)} required placeholder="DNI o pasaporte" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
                        </div>
                        {menores.length > 1 && (
                            <button type="button" onClick={() => eliminarMenor(index)} className="mt-5 px-2 py-1 bg-danger-600 text-white text-xs rounded hover:bg-danger-700 transition-colors" title="Eliminar menor">✕</button>
                        )}
                    </div>
                </div>
            ))}
            <button type="button" onClick={agregarMenor} className="px-4 py-2 bg-gray-600 text-white text-sm font-medium rounded-md hover:bg-gray-700 transition-colors">+ Agregar otro menor</button>
        </div>
    );
};

export default TomarDatosMenoresForm;
